import React from 'react';

import { Alert, Button } from 'antd';
import { Link } from 'react-router-dom';

import BoxContainer from '@src/components/BoxContainer';
import Title from '@src/components/BoxContainer/components/Title';
import FilterContainer from '@src/components/FilterContainer';
import IntlMessages from '@src/util/IntlMessages';

import { useEmergencyAccess } from '../hooks/useEmergencyAccess';
import styles from '../styles.module.less';

export const withEmergencyCommandCenterAccess = (
  Component: React.ComponentType,
): React.FC => {
  const EmergencyCommandCenterAccessGate: React.FC = () => {
    const { hasCommandCenterAccess } = useEmergencyAccess();

    if (!hasCommandCenterAccess) {
      return (
        <>
          <BoxContainer fullContent fixed bottomBorder>
            <FilterContainer
              title={
                <Title.Header value={<IntlMessages id="emergencies.commandCenter.title" />} />
              }
            />
          </BoxContainer>
          <div className={styles.screen}>
            <Alert
              className={styles.feedback}
              type="warning"
              showIcon
              message={<IntlMessages id="emergencies.commandCenter.accessDenied" />}
              description={
                <IntlMessages id="emergencies.commandCenter.accessDenied.description" />
              }
              action={
                <Link to="/">
                  <Button size="small">
                    <IntlMessages id="button.goBack" />
                  </Button>
                </Link>
              }
            />
          </div>
        </>
      );
    }

    return <Component />;
  };

  return EmergencyCommandCenterAccessGate;
};
